import React from 'react';
import './FooterView.css';
import Link from 'gatsby-link';

const FooterView = () => (
  <div className="footer-view-body">
    <ul className="footer-view-links">
      <Link to="/">
        <li>
          accueil
        </li>
      </Link>
      <Link to="/sites-vitrine">
        <li>
          Site vitrine
        </li>
      </Link>
      <Link to="/ecommerce">
        <li>
          ecommerce
        </li>
      </Link>
      <Link to="/applications-sur-mesure">
        <li>
          applications sur mesure
        </li>
      </Link>
      <Link to="/references">
        <li>
          références
        </li>
      </Link>
      <Link to="/blog">
        <li>
          blog
        </li>
      </Link>
      <Link to="/#contact">
        <li>
          contact
        </li>
      </Link>
      <Link to="/mentions-legales">
        <li>
          Mentions Légales
        </li>
      </Link>
    </ul>
    <div className="copyright">
      © 2001-2018 Com des Lézards.
      <br />
      All Rights Reserved.
    </div>
  </div>
);

export default FooterView;



// WEBPACK FOOTER //
// ./src/components/FooterView/FooterView.jsx